import { makeVar } from "@apollo/client";
import { NetworkError } from "@apollo/client/errors";
import { GraphQLError } from "graphql";

export interface GraphQLErrorsVar {
  retry(): void;
  graphQLErrors?: ReadonlyArray<GraphQLError>;
  networkError?: NetworkError;
}

export const errorsVar = makeVar<GraphQLErrorsVar | undefined>(undefined);
